import base from "@/fstore";
import validation from "@/fstore/validation";
import moment from 'moment';

const db = base.db;
const collection = "skills";
const model = db.collection(collection);

const template = {
  dateAdded: {
    type: 'object',
    default: new Date()
  },
  name: {
    type: 'string',
    required: true
  },
  addedBy: {
    type: 'object',
    required: true
  },
  active: {
    type: 'boolean',
    default: true
  }
}

const _getData = refs => {
  const docs = [];
  if (!refs.docs.length) {
    return docs;
  }

  refs.docs.forEach(doc => {
    let skill = null;
    if (doc.exists) {
      skill = doc.data();
    }

    if (skill !== null) docs.push(skill);
  });

  return docs;
};


const create = async (skill) => {
  const response = await validation.validateModel(model, skill, template);
  if (!response.errors.length) await model.add(response.doc);

  return response;
}

const getAll = async () => {
  const snapshot = await model.get();
  return snapshot.docs.map(doc => doc.data());
}

const getActive = async () => {
  const snapshot = await model.where('active', '==', true).orderBy('name').get();
  return snapshot.docs.map(doc => doc.data());
}

const getById = async (skillId) => {
  const doc = model.doc(skillId).get();

  if (!doc.exists) {
    return new Error({ code: 404, message: `Skill '${skillId}' was not found` });
  }

  doc = doc.data();
  return doc;
}

const getRef = async (skillId) => {
  const ref = await model.doc(skillId);
  return ref;
}

const getByName = async (skillName) => {
  const refs = await model.where('name', '==', skillName).get();
  const skills = _getData(refs);
  return skills;
}

const update = async (skillId, skill) => {
  const result = await model.doc(skillId).set(skill, { merge: true });
  return result;
}

const remove = async (skillId) => {
  // cannot remove skills that aren't disabled
  // if (!skill.disabled) {
  //   return new error({ code: 422, message: 'Cannot remove active skills. Please disable the skill prior to removing.' });
  // }

  const docRemoved = await model.doc(skillId).delete();
  return docRemoved;
}

const _getNullValueForField = (field) => {
  switch (template[field].type) {
    case "string":
      return "";
    case "object":
      return {};
    default:
      return null;
  }
}

const getTemplate = () => {
  const data = {}
  for (const field in template) {
    if (template[field].required)
      data[field] = _getNullValueForField(field);
    else
      data[field] = template[field].default;
  }

  return data;
}

export default {
  create,
  getAll,
  getActive,
  getById,
  getRef,
  getByName,
  getTemplate,
  update,
  remove
}
